import { Block } from '@xprog/prensa'
import { find, get, map } from 'lodash'
import { ArticleContext } from 'providers/Article'
import { PagesContext } from 'providers/Pages'
import React, { useContext, memo } from 'react'
import MD5 from "crypto-js/md5"

import { ComponentSwitch } from './Base.index'
import SlotMainColumn from './Base.Slots.styled'
import AdsSlot from "../Ads/Ads.Slot";

const MainContentBlock = ({ contentBlock, contentSide }) => {
  const slots = contentBlock.concat(contentSide)
  if (slots.length == 0) {
    return <></>
  }
  const variant = contentSide && contentSide.length > 0 ? 'twoColumns' : 'oneColumn'

  const megaDataSlot = {
    contentBlock,
    contentSide
  }

  return (
    <>
      <AdsSlot type="mega" componentReference='top' data={megaDataSlot} />
      <SlotMainColumn variant={variant}>
        <Block className='MainContent'>
          {map(contentBlock, (data, key) => {
            return <ComponentSwitch data={data} key={key} />
          })}
        </Block>
        <Block className='SideContent'>
          {map(contentSide, (data, key) => {
            return (
              <>
                <AdsSlot type="side"  componentReference='top' data={data} />
                <ComponentSwitch data={data} key={key} />
                <AdsSlot type="side"  componentReference='bottom' data={data} />
              </>
            )
          })}
        </Block>
      </SlotMainColumn>
      <AdsSlot type="mega" componentReference='bottom' data={megaDataSlot} />
    </>
  )
}

const MemoizedMainContentBlock = memo(MainContentBlock,
  (prevProps, nextProps) =>
  {
    // Creating an MD5 hash of the props to prevent a second render of blocks
    // with the same props since changes in the context will create a cascade effect
    // triggering the render of all children's components
    const prevPropsString = JSON.stringify(prevProps, null, 2)
    const nextPropsString = JSON.stringify(nextProps, null, 2)
    const prevPropsMD5Hash = MD5(prevPropsString).toString()
    const nextPropsMD5Hash = MD5(nextPropsString).toString()

    return prevPropsMD5Hash === nextPropsMD5Hash
  }
)

const RenderSlots = () => {
  const { pageList, pageListData, pageLoading } = useContext(PagesContext)
  const { articles } = useContext(ArticleContext)

  let slotsData = pageListData
  let slotsList = pageList

  const getItem = (value) => {
    const items: Array<{}> = []
    map(get(slotsList, value, []), (item) => {
      const policy = { id: item.replace('contentid/', 'policy:') }
      const found = find(slotsData, policy)
      found && items.push(found)
    })
    return items
  }

  let contentPage

  const haveArticles = articles && articles.length > 0
  if (haveArticles) {
    contentPage = [
      { contentBlock: getItem('p2g1slot1list'), contentSide: getItem('p2g1slot2list') },
      { contentBlock: getItem('p2g2slot1list'), contentSide: getItem('p2g2slot2list') },
      { contentBlock: getItem('p3g1slot1list'), contentSide: getItem('p3g1slot2list') },
      { contentBlock: getItem('p3g2slot1list'), contentSide: getItem('p3g2slot2list') },
      { contentBlock: getItem('p3g3slot1list'), contentSide: getItem('p3g3slot2list') },
      { contentBlock: getItem('p3g4slot1list'), contentSide: getItem('p3g4slot2list') },
      { contentBlock: getItem('p2g3slot1list'), contentSide: getItem('p2g3slot2list') },
      { contentBlock: getItem('p2g4slot1list'), contentSide: getItem('p2g4slot2list') },
    ]
  } else {
    contentPage = []
    contentPage.push({ contentBlock: getItem('p2g1slot1list'), contentSide: getItem('p2g1slot2list') })
    contentPage.push({ contentBlock: getItem('p2g2slot1list'), contentSide: getItem('p2g2slot2list') })
    contentPage.push({ contentBlock: getItem('p1g1slot1list'), contentSide: getItem('p1g1slot2list') })
    contentPage.push({ contentBlock: getItem('p1g2slot1list'), contentSide: getItem('p1g2slot2list') })
    contentPage.push({ contentBlock: getItem('p1g3slot1list'), contentSide: getItem('p1g3slot2list') })
    contentPage.push({ contentBlock: getItem('p1g4slot1list'), contentSide: getItem('p1g4slot2list') })
    contentPage.push({ contentBlock: getItem('p1g5slot1list'), contentSide: getItem('p1g5slot2list') })
    contentPage.push({ contentBlock: getItem('p1g6slot1list'), contentSide: getItem('p1g6slot2list') })
    contentPage.push({ contentBlock: getItem('p1g7slot1list'), contentSide: getItem('p1g7slot2list') })
    contentPage.push({ contentBlock: getItem('p1g8slot1list'), contentSide: getItem('p1g8slot2list') })
    contentPage.push({ contentBlock: getItem('p2g3slot1list'), contentSide: getItem('p2g3slot2list') })
    contentPage.push({ contentBlock: getItem('p2g4slot1list'), contentSide: getItem('p2g4slot2list') })
  }

  if (pageLoading) {
    return (
      <></>
    )
  }
  return (
    <>
      {map(contentPage, ({ contentBlock, contentSide }, key) => {
        return (
          <MemoizedMainContentBlock
            contentBlock={contentBlock}
            contentSide={contentSide}
            key={key}
          />
        )
      })}
    </>
  )
}

export default RenderSlots
